import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";

import { Button } from "components/ui/button";
import { DialogClose, DialogOverlay, DialogPortal } from "components/ui/dialog";
import { cn } from "lib/utils";

type DialogCardProps = {
    children: React.ReactNode;
    closeLabel: string;
    className?: string;
};

const DialogCard: React.FC<DialogCardProps> = ({ children, closeLabel, className }) => (
    <DialogPortal>
        <DialogOverlay className="bg-black/80 backdrop-blur-none" />
        <DialogPrimitive.Content
            className={cn(
                "dialog-centered-content fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-5xl bg-white shadow-2xl",
                className,
            )}
        >
            <div className="pointer-events-none absolute right-0 -top-36 h-72 w-72 translate-x-1/2 rounded-full bg-indigo-500/10 blur-4xl" />

            <DialogClose asChild>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="absolute right-6 top-6 z-10 rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200 focus-visible:ring-indigo-600"
                    aria-label={closeLabel}
                >
                    <X className="size-5" aria-hidden="true" />
                    <span className="sr-only">{closeLabel}</span>
                </Button>
            </DialogClose>

            <div className="relative flex flex-col gap-8 px-10 pb-10 pt-10">
                {children}
            </div>
        </DialogPrimitive.Content>
    </DialogPortal>
);

export { DialogCard };
